import type { Icon } from '../../../src/lib/types'
export const mdiChevronDown: Icon = {
  "id": "chevron-down",
  "name": "Chevron Down",
  "path": "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
  "as": [
    "expand-more",
    "keyboard-arrow-down"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiChevronDown